<template>
  <div class="wrap">
    <div class="left"></div>
    <div class="right">
      <div class="loginBox">
        <div class="logo"><img src="@/assets/image/logo.png" alt=""></div>
        <div class="username">
          <div class="int">
            <el-input v-model="form.username" placeholder="请输入电子邮箱"></el-input>
          </div>
        </div>
        <div class="username">
          <div class="int">
            <el-input v-model="form.password" placeholder="请输入密码"></el-input>
          </div>
        </div>
        <div class="username">
          <div class="int">
            <el-input v-model="form.surePassword" placeholder="请再次输入密码"></el-input>
          </div>
        </div>
        <div class="btnbox">
          <div>
            <el-tooltip :class="!isCompany?'buttint':'buttints'" effect="light" content="个人:指个人或团队参赛的一般选手" placement="bottom">
              <el-button>个人<i class="el-icon-warning-outline" style="margin-left: 8px"></i></el-button>
            </el-tooltip>
          </div>
          <div><el-button :class="isCompany?'buttint':'buttints'">企业</el-button></div>
        </div>
        <div class="btn">
          <el-button class="buttint">注册</el-button>
        </div>
        <div class="check">
          <div><el-checkbox v-model="checked">已阅读，并同意 旭麓新材料网《用户协议》</el-checkbox></div>
        </div>

        <div class="register">
          <div class="line"></div>
          <div class="name" @click="goLogin">已有账号,立即登录</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      form: {
        username: "",
        password: "",
        surePassword:""
      },
      checked:false,
      isCompany:false
    }
  },
  methods:{
    goLogin(){
      this.$router.push("/Login")
    },

  }
}
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;
  display: flex;

  .left {
    width: 60%;
    height: 100vh;
    background: url('../../assets/image/leftImg.png') no-repeat;
    background-position: center;
    background-size: cover;
  }

  .right {
    width: 40%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .loginBox {
      width: 40%;
      height: 50vh;

      .logo {
        width: 100%;
        padding: 30px 0;
        display: flex;
        justify-content: center;
      }

      .username {
        text-align: left;
        width: 100%;

        .name {
          font-weight: bold;
        }

        .nameEnglish {
          padding-left: 20px;
          font-size: 14px;
        }
        .int{
          padding: 10px 0;
        }
      }
      .btnbox{
        width: 100%;
        display: flex;
        justify-content: space-between;
        div{
          width: 48%;
          .buttint{
            width: 100%;
            background-color: #25877d;
            color: #ffffff;
          }
          .buttints{
            width: 100%;
          }
          .buttints:hover{
            background-color: #ffffff;
            border: 1px solid #C0C0C0;
            color: #000000;
          }
        }
      }
      .btn{
        width: 100%;
        padding: 30px 0;
        .buttint{
          width: 100%;
          background-color: #25877d;
          color: #ffffff;
        }
      }
      .check{
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .register{
        width: 100%;
        height: 60px;
        align-items: center;
        display: flex;
        .line{
          width: 25%;
          height: 6px;
          background-color: #25877d;
        }
        .name{
          width: 50%;
          text-align: center;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Login/register.vue